import { Outlet } from 'react-router';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-t90-navy via-t90-navy-light to-t90-teal p-4">
      <div className="w-full max-w-md">
        <Outlet />
      </div>
    </div>
  );
}
